import type { ComponentSingleStyleConfig } from "@chakra-ui/react"

export const Divider: ComponentSingleStyleConfig = {
  baseStyle: {
    borderColor: "line",
    opacity: 1,
  },
}
